import * as uiInternal from '@servicenow/ui-internal';
import onConnect from './onConnect';
import onStateChange from './onStateChange';
import onDisconnect from './onDisconnect';
import createSlot from './createSlot';

const {createAriaRef} = uiInternal;
export default {
	createSlot,
	onConnect,
	onDisconnect,
	onStateChange,
	deprioritizeStyles: true
};

/**
 * Added explicit export because some components
 * are importing react from this package
 */
export * as react from 'react';
export {createSlot, createAriaRef};
